// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","skeletonWrapper":"skeleton_skeletonWrapper__N5VRp","shimmer":"skeleton_shimmer__Udb_l"};